module.exports = __webpack_public_path__ + "media/images/gallery/gal_off-f19151608fdae50e47c2618587987bf8.gif";